export const buildLandingUrl = (window: Window) => {
  let url = `${window.location.protocol}//${window.location.hostname}`;
  if (window.location.port) {
    url += `:${window.location.port}`;
  }
  return url;
};
